/**
 * Central notification dispatch — all client-initiated alerts flow through here.
 * Social events (friend/challenge/message) are handled server-side via Firestore triggers.
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

let dispatchFn = null;

function getDispatchFn() {
  if (!dispatchFn) {
    dispatchFn = httpsCallable(functions, 'dispatch_notification');
  }
  return dispatchFn;
}

/**
 * @param {Object} params
 * @param {string} params.userId — target user (must be self for callable)
 * @param {string} params.type — friend_request | challenge | message | system
 * @param {string} params.title
 * @param {string} params.body
 * @param {Record<string, unknown>} [params.data]
 * @param {'low'|'medium'|'high'} [params.priority]
 * @param {string} [params.dedupeKey]
 * @param {boolean} [params.group]
 */
export async function sendNotification({
  userId,
  type,
  title,
  body,
  data = {},
  priority = 'medium',
  dedupeKey,
  group = false,
}) {
  if (!userId || !type) return null;
  try {
    const result = await getDispatchFn()({
      userId,
      type,
      title,
      body,
      data,
      priority,
      dedupeKey,
      group,
    });
    return result?.data ?? null;
  } catch (err) {
    console.warn('sendNotification:', err?.message || err);
    return null;
  }
}
